let practice_invite = function( $ ) {

	let $wrapper;

	let _init = function() {
		$wrapper = $( '#practice-invite' );

		if ( $wrapper.length > 0 ) {
			_setup_accept_invite()
		}
	};

	let _setup_accept_invite = function() {
		$wrapper.find( 'a.accept-invite' ).on( 'click', function( e ) {
			e.preventDefault();

			if ( $( this ).attr( 'href' ).startsWith( '#' ) ) {
				_update_staff_status( 'accepted', false );
			} else {
				_update_staff_status( 'accepted', $( this ).attr( 'href' ) );
			}
		} );

	};

	let _update_staff_status = function( status, redirect ) {
		let data = {
			nonce: ScriptData.crate_update_staff_status_nonce,
			action: 'crate_update_staff_status',
			value: status,
			invite_id: $wrapper.find( 'a.accept-invite' ).data( 'invite' )
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			console.log( response );

			if ( response.success ) {
				$wrapper.trigger( 'updated_staff_status', response );

				if ( redirect ) {
					window.location.href = redirect;
				}
			} else {
				$wrapper.trigger( 'error_updating_staff_status', response );

				if ( response.error == 'Already accepted.' ) {
					if ( redirect ) {
						window.location.href = redirect;
					}
				}
			}
		} );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = practice_invite;